import { gql } from "@apollo/client";
import { ContentfulComponentType } from "../types";
import { StructuredData } from "../../../../__generated__/graphql";
import Head from "next/head";

export const ContentfulStructuredData: ContentfulComponentType<
  StructuredData
> = ({ structuredData, sys }) => {
  return (
    <Head key={sys.id}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      ></script>
    </Head>
  );
};

ContentfulStructuredData.fragment = gql`
  fragment StructuredData on ComponentStructuredData {
    structuredData
    sys {
      id
      publishedAt
    }
  }
`;
